<template>
  <section v-if="!loading && items.length > 0" class="prten pt-md-10 pt-4">
    <v-container>
      <div class="text-center section-header">
        <h2 class="section-title">
          {{ $t("Success_Partners") }}
        </h2>
        <p class="section-subtitle">
          {{ $t("Partners_whose_partnership") }}
        </p>
      </div>
    <Carousel v-bind="settings" :autoplay="2200" :breakpoints="breakpoints" :wrap-around="true">
    <Slide v-for="(item, i) in items" :key="i">
      <div class="carousel__item partenr_img">
          <img :src="item.image" class="" />
      </div>
    </Slide>
  
    <template #addons>
      <Navigation />
    </template>
  </Carousel>
    </v-container>
 
   
  </section>
  <v-row v-else>
    <template v-if="loading">
      <v-col cols="12" v-for="text in texts" :key="text">
        <v-skeleton-loader
          class="mx-auto border-0"
          type="paragraph"
        ></v-skeleton-loader>
      </v-col>
    </template>
    <template v-else>
      <v-col cols="12" class="d-flex justify-center align-center">
        <div class="no-services-card">
          <p class="no-services-text">{{ $t('no_partners_now') }}</p>
        </div>
      </v-col>
    </template>
  </v-row>
</template>
<script>
import crudDataService from "../../Services/crudDataService.js";
import { Carousel, Navigation, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'
export default {
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data() {
    return {
      settings: {
      itemsToShow: 1,
      snapAlign: 'center',
    },
    breakpoints: {
      // 700px and up
      700: {
        itemsToShow: 3.5,
        snapAlign: 'center',
      },
      // 1024 and up
      1024: {
        itemsToShow: 6,
        snapAlign: 'start',
      },
    },
  items: [],
  texts: [1, 2, 3, 4, 5, 6],
  loading: true,
    };
  },
  methods: {
    async sponsers() {
      this.loading = true;
      try {
        let response = await crudDataService.getAll("sponsors");
        this.items = response.data;
      } catch (e) {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.sponsers();
  },
};
</script>
<style lang="scss">
.partenr_img {
  width: 100%;
  height: 120px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
  
  &:hover {
    border-color: #0074c7;
    box-shadow: 0 2px 8px rgba(0, 116, 199, 0.1);
  }
}

.partenr_img img {
  width: 80%;
  height: auto;
  object-fit: contain;
}

.partenr_img .v-img__img--contain {
  width: 100%;
  object-fit: contain;
  margin: auto;
}

@media (max-width: 991.98px) {
  .partenr_img {
    height: 100px;
    padding: 8px;
  }
  
  .partenr_img img {
    width: 70%;
  }
}

@media (min-width: 960px){
.prten .v-container {
    max-width: 1108px;
}}
@media (min-width: 1280px){
.prten .v-container {
    max-width: 1470px;

}

}

</style>
<style lang="scss" scoped>
.prten {
  background: #ffffff;
  padding: 32px 0;
}

.section-header {
  margin-bottom: 32px;
}

.section-title {
  font-size: clamp(24px, 4vw, 32px);
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.section-subtitle {
  font-size: clamp(16px, 2.5vw, 20px);
  color: #666;
  font-weight: 400;
  margin: 0;
}

.no-services-card {
  background: #f5f5f5;
  border-radius: 8px;
  padding: 32px 0;
  width: 80%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  border: 1px solid #e0e0e0;
}

.no-services-text {
  color: #666;
  font-size: clamp(18px, 3vw, 24px);
  font-weight: 500;
  margin: 0;
}

@media (max-width: 600px) {
  .prten {
    padding: 24px 0;
  }
  
  .section-header {
    margin-bottom: 24px;
  }
}
</style>
